import { useEffect, useState } from 'react';
import { IPieChart } from '../Models/PieChartModel';
import './PieChart.scss';

export const PieChart = (props: IPieChart) => {
  const [unRounded, setUnRounded] = useState<number>(0);
  const [percent, setPercent] = useState<number>(0);
  const [noData, setNoData] = useState<boolean>(false);
  const [gradient, setGradient] = useState<string>('');
  const [rotated, setRotated] = useState<number>(0);
  const [lessThan20, setLessThan20] = useState(props.lessThan20);
  const [greaterThan20, setGreaterThan20] = useState(props.greaterThan20);
  const [isTesting] = useState<boolean>(sessionStorage.getItem('iaportals-testing') == 'true'); //for internal testing purposes only

  useEffect(() => {
    if (lessThan20 != undefined && greaterThan20 != undefined) {
      if (lessThan20 == 0 && greaterThan20 == 0) setNoData(true);
      else {
        setNoData(false);
        setUnRounded((greaterThan20 / (greaterThan20 + lessThan20)) * 100);
      }
    }
  }, [greaterThan20, lessThan20]);

  useEffect(() => {
    //don't reflect 100% unless it really is
    if (unRounded > 0 && unRounded < 1) setPercent(1);
    else if (unRounded > 99 && unRounded < 100) setPercent(99);
    else setPercent(Math.round(unRounded));
  }, [unRounded]);

  useEffect(() => {
    if (percent == 0) setGradient('conic-gradient(#1a1446 100%)');
    else if (percent == 100) setGradient('conic-gradient(#ffd000 100%)');
    else if (lessThan20 >= greaterThan20) {
      setGradient(`conic-gradient(#1a1446 ${100 - percent}%, #ffd000 ${percent}%)`);
      setRotated((percent / 2 / 100) * 360 + 45);
    } else if (greaterThan20 > lessThan20) {
      setGradient(`conic-gradient(#ffd000 ${percent}%, #1a1446 ${100 - percent}%)`);
      setRotated(((100 - percent) / 2 / 100) * 360 + 45 + 180);
    }
  }, [percent, lessThan20, greaterThan20]);

  return (
    <>
      {isTesting && (
        <div className="piechart-testing-inputs">
          <input
            type="number"
            value={lessThan20}
            onChange={(e) => setLessThan20(parseInt(e.target.value ?? ''))}
          ></input>
          <input
            type="number"
            value={greaterThan20}
            onChange={(e) => setGreaterThan20(parseInt(e.target.value ?? ''))}
          ></input>
        </div>
      )}
      <div id="pie-chart">
        <div
          className={`blue-circle ${noData ? 'no-data' : ''}`}
          style={{ backgroundImage: gradient, transform: `rotate(${rotated}deg)` }}
        >
          <div className="inner-circle" style={{ transform: `rotate(${360 - rotated}deg)` }}>
            <div>
              <div>
                <b>Premium change</b>
              </div>
              <div className="less-than-twenty change-label">&lt; 20%: {lessThan20}</div>
              <div className="greater-than-twenty change-label">&#8805; 20%: {greaterThan20}</div>
            </div>
          </div>
        </div>
        {percent != 100 && (
          <div className={`pie-chart-label blue-label ${percent == 0 ? 'one-hundred' : 'bottom-left-shifted'}`}>
            {100 - percent}%
          </div>
        )}
        {percent != 0 && (
          <div className={`pie-chart-label yellow-label ${percent == 100 ? 'one-hundred' : 'top-right-shifted'}`}>
            {percent}%
          </div>
        )}
      </div>
    </>
  );
};
